<template>
  <div class="landing-page">

    <!-- HERO SECTION -->
    <section class="hero-section my-5">

      <div class="hero-container">
        <h2>Seamless Travel and Relocation Solutions</h2>
        <p>
          Simplify your journey with our expert services. Let us provide you
          with the information you need to make your travel and relocation
          experience effortless and smooth!
        </p>
        <router-link to="/travel-consultation" class="btn btn-royal-blue">
          Consult an expert
        </router-link>
      </div>
    </section>

    <div class="container my-5">
      <div class="mission-section text-center p-4"
        style="border-radius: 20px; background-color: #e0f0ff; padding: 30px;">
        <h4>Our Mission</h4>
        <p class="mt-3">
          We are driven by a mission to connect Africa with the world through seamless travel, impactful education,
          business exchange,
          and international partnerships. Guided by professionalism, integrity, and customer satisfaction,
          GAA Africa International stands as a trusted partner for global opportunities.
        </p>
      </div>
    </div>


    <!-- INFO SECTION -->
    <section class="info-sections my-5">
      <div class="container">
        <h1>Discover Experiences That Inspire You</h1>
        <p>
          From breathtaking destinations to tailored travel packages — explore, unwind, and make every journey
          unforgettable.
        </p>

        <div class="row">
          <div class="col-md-4">
            <div class="info-container"> <img src="@/assets/images/cape_town.jpg" alt="Image 1" class="info-image" />
              <div class="info-content">
                <h3>Title 1</h3>
                <p>Description for the first section goes here.</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info-container"> <img src="@/assets/images/packaging.jpg" alt="Image 2" class="info-image" />
              <div class="info-content">
                <h3>Title 2</h3>
                <p>Description for the second section goes here.</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info-container"> <img src="@/assets/images/safari.jpg" alt="Image 3" class="info-image" />
              <div class="info-content">
                <h3>Title 3</h3>
                <p>Description for the third section goes here.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


          <!-- ADVERTISING SECTION -->
    <section class="advertising-section my-5">
      <div class="container">
        <div class="advertising-wrapper text-center">
          <h2>Travel Packages</h2>
          <p class="advertising-subtitle">
            Explore our featured destinations and enjoy curated travel experiences designed for comfort, adventure, and unforgettable memories.
          </p>

          <div class="row g-4 mt-4">
            <div class="col-md-4">
              <div class="advert-card">
                <img src="@/assets/images/adv1.png" alt="Hartbeespoort Package" class="advert-image" />
              </div>
            </div>

            <div class="col-md-4">
              <div class="advert-card">
                <img src="@/assets/images/adv2.png" alt="Sun City Package" class="advert-image" />
              </div>
            </div>

            <div class="col-md-4">
              <div class="advert-card">
                <img src="@/assets/images/adv3.png" alt="Sun City Package" class="advert-image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- STATIC PROMO ROW -->
    <section class="promo-row my-5">
      <div class="container promo-container">
        <!-- Card 1: Blueish tone -->
        <div class="promo-banner promo-blue text-center">
          <h2>Your Strategic Partner in Global Education</h2>
          <p>
            GAA Africa International delivers end-to-end educational consulting services — connecting students with
            globally accredited universities through transparent, structured, and result-driven processes.
We simplify your international study journey with precision, professionalism, and care.
          </p>
        </div>

        <!-- Card 2: Greenish tone -->
        <div class="promo-banner promo-green text-center">
          <h2>Visa Support Made Simple</h2>
          <p>
            We facilitate your visa process and assist with all enquiries — from documentation
            to travel guidance — making your international journey stress-free.
          </p>
        </div>
      </div>
    </section>

    

    <!-- SCROLLING IMAGES ONLY -->
    <section class="scrolling-section my-5">
      <div class="scrolling-wrapper">
        <div class="scrolling-track">
          <img v-for="(img, i) in scrollingImages" :key="i" :src="img" alt="scrolling-img" class="scroll-img" />
          <!-- duplicate set for infinite loop -->
          <img v-for="(img, i) in scrollingImages" :key="'dup-' + i" :src="img" alt="scrolling-img"
            class="scroll-img" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {

      scrollingImages: [
        require("@/assets/images/canada_tour.jpeg"),
        require("@/assets/images/finland_intake.jpeg"),
        require("@/assets/images/regent_college.jpeg"),
        require("@/assets/images/canada2.jpeg"),
        require("@/assets/images/finland2.jpeg"),
      ],
    };
  },
};
</script>

<style scoped>
/* HERO SECTION */
.hero-section {
  margin: 10px 0;
  background-image: url("@/assets/images/flight_landing.jpg");
  background-size: cover;
  background-position: center;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.hero-container {
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 20px;
}

.btn-royal-blue {
  background-color: #2c787e;
  color: white;
  border: none;
}

.btn-royal-blue:hover {
  background-color: #256b6e;
}

/* INFO IMAGE GRID */
.info-container {
  height: 250px;
  margin: 20px 0;
  background-color: #2c787e;
  border-radius: 20px;
  overflow: hidden;
}

.info-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 20px;
}

/* SCROLLING IMAGE STRIP */
.scrolling-section {
  overflow: hidden;
  background-color: #f8f9fa;
  padding: 20px 0;
}

.scrolling-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.scrolling-track {
  display: flex;
  width: max-content;
  animation: scroll-left 30s linear infinite;
}

.scroll-img {
  width: 300px;
  height: 200px;
  object-fit: cover;
  border-radius: 15px;
  margin-right: 20px;
}

/* Parent wrapper section */
.promo-row {
  background-color: rgba(44, 120, 126, 0.08);
  /* soft bluish tint */
  border-radius: 25px;
  /* rounded outer corners */
  padding: 40px 50px;
  /* inner padding */
  margin: 50px auto;
  width: 95%;
  max-width: 1300px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* Flex container for inner cards */
.promo-container {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 40px;
}

/* Individual cards */
.promo-banner {
  flex: 1;
  min-width: 400px;
  border-radius: 20px;
  /* round the cards themselves */
  padding: 40px 30px;
  /* inner text padding */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.promo-banner:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

/* Color variants */
.promo-blue {
  background: rgba(44, 120, 126, 0.15);
  border: 2px solid rgba(44, 120, 126, 0.4);
}

.promo-green {
  background: rgba(46, 180, 120, 0.15);
  border: 2px solid rgba(46, 180, 120, 0.4);
}

/* Responsive stacking */
@media (max-width: 768px) {
  .promo-container {
    flex-direction: column;
    align-items: center;
  }

  .promo-banner {
    width: 100%;
    min-width: unset;
  }

  .mission-section {
    max-width: 800px;
    margin: 3rem auto 0 auto;
    padding: 40%;
    margin-left: 20%;
    margin-right: 20%;

  }
}


/* Animation */
@keyframes scroll-left {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .scroll-img {
    width: 200px;
    height: 150px;
  }
}

/* ADVERTISING SECTION */
.advertising-section {
  background: linear-gradient(135deg, #f4fbfb, #eef7f8);
  padding: 60px 0;
}

.advertising-wrapper {
  border-radius: 25px;
  padding: 40px 25px;
  background: white;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.06);
}

.advertising-wrapper h2 {
  color: #2c787e;
  font-weight: 700;
  margin-bottom: 10px;
}

.advertising-subtitle {
  max-width: 800px;
  margin: 0 auto;
  color: #555;
  font-size: 1rem;
}

.advert-card {
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  height: 100%;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.advert-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.advert-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.advert-text-card {
  padding: 30px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  background: rgba(44, 120, 126, 0.08);
}

.advert-text-card h3 {
  color: #2c787e;
  margin-bottom: 15px;
}

.advert-text-card p {
  color: #444;
  line-height: 1.7;
}
</style>

